var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "col-12 confirm-content" }, [
    _c("p", [
      _vm._v(_vm._s(_vm.$t("home.widgets.list.lostcom_confirm_content"))),
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n    " +
          _vm._s(
            _vm.$t("home.widgets.list.lostcom_confirm_content_profile_text")
          ) +
          "\n    "
      ),
      _c(
        "button",
        {
          staticClass: "underline btn-unstyled",
          on: { click: _vm.handleProfileSetting },
        },
        [
          _vm._v(
            "\n      " +
              _vm._s(
                _vm.$t("home.widgets.list.lostcom_confirm_content_profile_link")
              ) +
              "\n    "
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }